// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3ZgbU","image":"Card_image__1GSTU"};